import { takeEvery } from 'redux-saga/effects';

import { redirect, redirectActions } from '@entities/history';
import { bookCreatingModel } from '@features/book-creating';

export function* createBookPageWorker() {
  yield takeEvery(bookCreatingModel.actions.createBookClick, bookCreatingModel.saga.createNewBook);
  yield takeEvery(redirectActions.toBooksClick, redirect.toBooks);
}
